/**
 * French Translations
 */

export const fr = {
  // Common
  continue: "Continuer",
  back: "← Retour",
  next: "Suivant",
  previous: "Précédent",
  submit: "Soumettre",
  cancel: "Annuler",
  save: "Enregistrer",
  edit: "Modifier",
  delete: "Supprimer",
  close: "Fermer",
  loading: "Chargement...",
  error: "Erreur",
  success: "Succès",
  warning: "Avertissement",
  info: "Information",
  required: "Obligatoire",
  optional: "Optionnel",
  
  // Property Valuation Result Storytelling Widget
  // Introduction Section
  propertyStoryIntro: "Faites défiler votre souris vers le bas et decouvrez les informations sur votre proprieté",
  
  // Chapter 1: The Property
  theProperty: "Le Bien",
  propertyDescription: "Chaque propriété a son histoire. Cet appartement de {living_area}m² à {city} existe depuis {year}.",
  propertyProfile: "Profil de la Propriété",
  propertyType: "Type de Bien",
  historicalContext: "Contexte Historique",
  yearBuilt: "Année de Construction",
  currentCondition: "État Actuel",
  parking: "Stationnement",
  
  // Chapter 2: The Location
  theLocation: "L'Emplacement",
  locationDescription: "L'emplacement est souvent considéré comme le facteur le plus important dans l'évaluation immobilière. Découvrons ce qui rend l'emplacement de cette propriété spécial.",
  landInformation: "Informations sur le Terrain",
  landType: "Type de Terrain",
  egridNumber: "Numéro EGRID",
  zoning: "Zonage",
  inForceSince: "En vigueur depuis le",
  
  // Map Controls
  streetView: "Vue de la Rue",
  satelliteView: "Vue Satellite",
  priceHeatmap: "Carte Thermique des Prix",
  zoningPlan: "Plan de Zonage",
  mapNotAvailable: "Carte interactive non disponible",
  mapLoadError: "Erreur de chargement de la carte",
  
  // Chapter 3: The Market
  theMarket: "Le Marché",
  marketDescription: "Comprendre le contexte plus large du marché aide à mettre en perspective la valeur de votre bien.",
  pricePerM2Comparison: "Comparaison du Prix au m²",
  medianPriceComparison: "Comparaison du Prix Médian",
  areaVsRegion: "Votre quartier vs Région de Genève",
  yourArea: "Votre Quartier",
  genevaRegion: "Région de Genève",
  localMarketTrends: "Tendances du Marché Local",
  averagePrice: "Prix Moyen Q1 2025",
  transactions: "Transactions Q1 2025",
  priceTrend: "Tendance des Prix (2023-2025)",
  regionalContext: "Contexte Régional",
  regionAverage: "Moyenne Région Genève",
  regionalTransactions: "Transactions Régionales",
  regionalTrend: "Tendance Régionale",
  
  // Chapter 4: The Neighborhood
  theNeighborhood: "Le Quartier",
  neighborhoodDescription: "La valeur d'une propriété est fortement influencée par ce qui l'entoure. Des équipements culturels aux nécessités quotidiennes, découvrons ce qui rend ce lieu spécial.",
  nearbyPoi: "Points d'Intérêt à Proximité",
  artCulture: "Art & Culture",
  cafe: "Café",
  financial: "Financier",
  publicUtility: "Service Public",
  environmentalFactors: "Facteurs Environnementaux",
  roadNoiseDay: "Bruit Routier (Jour)",
  roadNoiseNight: "Bruit Routier (Nuit)",
  railwayNoiseDay: "Bruit Ferroviaire (Jour)",
  railwayNoiseNight: "Bruit Ferroviaire (Nuit)",
  veryHigh: "Très Élevé",
  moderate: "Modéré",
  veryLow: "Très faible",
  neighborhoodScores: "Scores de Qualité du Quartier",
  neighborhoodQualityAssessment: "Évaluation de la Qualité du Quartier",
  neighborhoodQuality: "Qualité du Quartier",
  yourProperty: "Votre Propriété",
  genevaAverage: "Moyenne de Genève",
  shopping: "Shopping",
  grocery: "Alimentation",
  cultureEntertainment: "Culture et Divertissement",
  diningDrinking: "Restauration et Boissons",
  education: "Éducation",
  wellness: "Bien-être",
  healthcare: "Santé",
  transport: "Transport",
  basicAmenities: "Commodités de Base",
  outstandingCategories: "Catégories Exceptionnelles",
  cultureEntertainmentDesc: "10/10 - Accès aux musées, théâtres et lieux culturels",
  diningDrinkingDesc: "10/10 - Restaurants et cafés de haute qualité à proximité",
  educationDesc: "10/10 - Excellentes écoles et établissements d'enseignement",
  areasConsideration: "Points à Considérer",
  transportDesc: "7/10 - Options de transport bonnes mais limitées",
  healthcareDesc: "6/10 - Quelques établissements de santé à proximité mais spécialités limitées",
  
  // Chapter 5: The Value
  theValue: "La Valeur",
  valueDescription: "Maintenant que nous avons exploré la propriété, son emplacement, le contexte du marché et la qualité du quartier, nous pouvons présenter une évaluation complète basée sur tous ces facteurs.",
  goodConfidence: "Bonne Confiance",
  mediumConfidence: "Confiance Moyenne",
  lowConfidence: "Faible Confiance",
  priceAnalysis: "Analyse des Prix",
  pricePerM2: "Fourchette de Prix au m²",
  
  // Property Valuation Result MapDashboard Widget
  price: "Prix",
  zoning: "Zonage",
  noise: "Bruit",
  pricePerSquareMeter: "Prix par m²",
  estimatedValueRange: "Fourchette de valeur estimée",
  confidence: "Confiance",
  fullReport: "Rapport complet",
  share: "Partager",
  propertyDetails: "Détails de la propriété",
  propertyInformation: "Information sur la propriété",
  livingArea: "Surface habitable",
  yearBuilt: "Année de construction",
  marketAnalysis: "Analyse du marché",
  avgPricePerSquareMeter: "Prix moyen/m²",
  annualTrend: "Tendance annuelle",
  energyEnvironment: "Énergie & Environnement",
  energyRating: "Classe énergétique",
  noiseLevel: "Niveau de bruit",
  pointsOfInterest: "Points d'intérêt",
  low: "Faible",
  medium: "Moyen",
  high: "Élevé",
  
  // Property Valuation Widget
  // Step 1: Address Input
  whereProperty: "À quelle adresse se situe votre bien à estimer ?",
  enterAddress: "Entrez votre adresse",
  
  // Step 2: Location with Map
  isThisProperty: "Est-ce votre propriété?",
  confirmAddress: "Confirmer l'adresse",
  thisIsMyProperty: "C'est ma propriété",
  confirmLocation: "Confirmer l'emplacement",
  
  // Step 3b: Apartment Selection
  selectApartment: "Sélectionnez votre appartement",
  customApartment: "Appartement personnalisé",
  enterCustomDetails: "Entrez manuellement les détails de votre appartement",
  floor: "Étage",
  rooms: "Pièces",
  
  // Step 4: Property Details
  tellAboutProperty: "Quelle est la typologie de votre bien?",
  bedrooms: "Nombre de pièces",
  bathrooms: "Nombre de salles de bain",
  livingArea: "Surface habitable (m²)",
  landArea: "Surface du terrain (m²)",
  exactBedrooms: "Nombre exact de pièces",
  exactBathrooms: "Nombre exact de salles de bain",
  condition: "État",
  needsRenovation: "Nécessite rénovation",
  wellMaintained: "Bien entretenu",
  newOrRenovated: "Neuf ou récemment rénové",
  constructionYear: "Année de construction",
  regblPrefillData: "Nous préremplissons les données en utilisant le Registre fédéral des bâtiments et des logements (RegBL) quand nous le pouvons. Veuillez vérifier les détails.",
  
  // Step 5: Valuation Purpose
  valuationPurpose: "Quel est l'objectif de votre évaluation?",
  sellingSoon: "Vente prochaine",
  justCurious: "Simple curiosité",
  buyingSoon: "Achat prochain",
  refinancing: "Refinancement",
  whenSelling: "Quand prévoyez-vous de vendre?",
  asap: "Dès que possible",
  within3months: "D'ici 3 mois",
  threeToSixMonths: "3-6 mois",
  sixToTwelveMonths: "6-12 mois",
  justExploring: "J'explore les options",
  whatPrice: "À quel prix estimez-vous ce bien ?",
  helpUnderstand: "Cela nous aidera à comprendre vos attentes mais ne déterminera pas le prix de l'évaluation.",
  
  // Step 6: Loading/Processing
  processingData: "Traitement des données de votre bien",
  pleaseWait: "Veuillez patienter pendant que notre modèle analyse votre propriété...",
  analyzingLocation: "Analyse des données de localisation",
  findingComparables: "Recherche de biens comparables",
  calculatingTrends: "Calcul des tendances du marché",
  finalizingValuation: "Finalisation de l'évaluation",
  
  // Step 7: Contact Information
  valuationReady: "Votre évaluation est prête!",
  provideContact: "Veuillez fournir vos coordonnées pour recevoir votre rapport d'évaluation",
  fullName: "Nom complet",
  yourName: "Votre nom",
  emailAddress: "Adresse e-mail",
  yourEmail: "Votre e-mail",
  phoneNumber: "Numéro de téléphone",
  yourPhone: "Votre téléphone",
  title: "Titre",
  mr: "M.",
  mrs: "Mme.",
  ms: "Mlle.",
  firstName: "Prénom",
  lastName: "Nom",
  comment: "Commentaires supplémentaires (optionnel)",
  yourComment: "Dites-nous en plus sur vos besoins",
  agreeReceive: "J'accepte d'être contacté pour des questions ou des informations complémentaires et je confirme avoir pu consulter ",
  privacyPolicy: "la politique de confidentialité",
  getValuation: "Obtenir mon évaluation",
  
  // Step 8: SMS Verification
  verifyPhone: "Vérifiez votre numéro de téléphone",
  sentCode: "Nous avons envoyé un code à 4 chiffres à votre téléphone. Veuillez l'entrer ci-dessous pour vérifier votre numéro.",
  didntReceive: "Vous n'avez pas reçu de code?",
  resendCode: "Renvoyer le code",
  verifyView: "Vérifier et voir les résultats",
  
  // Step 8b: SMS code verification
  processingSmsCode: "Traitement du code SMS",
  pleaseWaitSmsCode: "Veuillez patienter pendant que nous vérifions votre numéro de téléphone...",
  
  // Step 9: Appraisal Result
  propertyValuation: "Évaluation de votre bien",
  estimatedRange: "Fourchette estimée:",
  confidence: "Confiance:",
  low: "Faible",
  medium: "Moyenne",
  high: "Élevée",
  valuationBased: "Cette évaluation est basée sur des ventes comparables récentes, les tendances du marché et les détails que vous avez fournis.",
  downloadReport: "Voir le rapport",
  contactAgent: "Contacter un agent",
  startNew: "Commencer une nouvelle évaluation",
  
  // Validation messages
  invalidEmail: "Veuillez entrer une adresse e-mail valide",
  invalidPhone: "Veuillez entrer un numéro de téléphone valide",
  requiredField: "Ce champ est obligatoire",
  minCharacters: "Veuillez entrer au moins {{min}} caractères",
  maxCharacters: "Veuillez entrer au maximum {{max}} caractères",
  minValue: "Veuillez entrer une valeur supérieure ou égale à {{min}}",
  maxValue: "Veuillez entrer une valeur inférieure ou égale à {{max}}",
  
  // Error messages
  errorFetchingAddresses: "Erreur lors de la recherche d'adresses. Veuillez réessayer.",
  errorFetchingBuilding: "Erreur lors de la récupération des détails du bâtiment. Veuillez réessayer.",
  errorVerifyingCode: "Erreur lors de la vérification du code. Veuillez réessayer.",
  errorSubmittingValuation: "Erreur lors de la soumission de l'évaluation. Veuillez réessayer.",
  
  // Property types
  apartment: "Appartement",
  house: "Maison",
  chalet: "Chalet",
  duplex: "Duplex",
  villa: "Villa",
  
  // Room formatting
  roomsFormat: "{{rooms}} pièces, {{bathrooms}} salle{{bathrooms_plural}} de bain",
  bathrooms_plural_0: "",
  bathrooms_plural_1: "",
  bathrooms_plural_n: "s",
  
  // Property conditions (matching API values)
  good_condition: "Bon état",
  needs_renovation: "Nécessite rénovation",
  new_renovated: "Neuf ou récemment rénové",
};